import { render, staticRenderFns } from "./voiceEditList.vue?vue&type=template&id=c68b8c68&scoped=true&"
import script from "./voiceEditList.vue?vue&type=script&lang=js&"
export * from "./voiceEditList.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/resource/voiceRec.less?vue&type=style&index=0&id=c68b8c68&lang=less&scoped=true&"
import style1 from "./voiceEditList.vue?vue&type=style&index=1&id=c68b8c68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68b8c68",
  null
  
)

component.options.__file = "voiceEditList.vue"
export default component.exports